import { useState } from 'react';
import { UseMutationResult } from 'react-query';
import { AuthResponseDto } from '@goparrot/dashboard-gateway-sdk';
import type { AxiosError } from 'axios';
import { UserBlockReasonEnum } from '@goparrot/users-v2-sdk';
import { LoginParams, useAfterLogin, useLogin } from '@goparrot-dashboard-api/auth';
import { useI18n } from '@goparrot-dashboard/i18n';
import { useNotifications } from '@goparrot-dashboard/shared-ui';

export type UseLoginWithHandlersReturnType = {
  login: UseMutationResult<AuthResponseDto, AxiosError, LoginParams>;
  errorMsg: string | null;
};

export const useLoginWithHandlers = (): UseLoginWithHandlersReturnType => {
  const { getIntlString } = useI18n();
  const { notifyError } = useNotifications();
  const afterLogin = useAfterLogin();

  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const login = useLogin({
    onSuccess: (res) => {
      afterLogin(res);
      setErrorMsg(null);
    },
    onError: (e) => {
      if (e?.response?.status === 401) {
        if (e?.response?.data.message === UserBlockReasonEnum.TOAST_DEPRECATION) {
          return setErrorMsg('error.toastDeprecationBanner.body');
        } else {
          notifyError({
            text: getIntlString('error.wrongPassword'),
          });
        }
      } else {
        notifyError({
          text: getIntlString('notification.genericErrorResponse', { isRootPath: true }),
        });
      }
      setErrorMsg(null);
    },
  });

  return { login, errorMsg };
};
